import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Dates.css";

export default function Dates() {
    const datesProducts = [
        {
            id: 1,
            name: "MEDJOOL DATES",
            image: "/assets/img/Dates/Medjool-Dates.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Premium dry fruit packs",
                        "Healthy snack products",
                        "Gift packaging",
                        "Desserts and sweets",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Large fruit size",
                        "Naturally sweet taste",
                        "Soft texture",
                        "Premium quality grade",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "AJWA DATES",
            image: "/assets/img/Dates/Ajwa-Dates.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Daily consumption",
                        "Religious occasions",
                        "Health food products",
                        "Premium date packs",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich nutritional value",
                        "Unique flavor",
                        "High consumer demand",
                        "Soft and chewy texture",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "SAFAWI DATES",
            image: "/assets/img/Dates/Safawi-Dates.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Premium date packs",
                        "Healthy snack products",
                        "Gift packaging",
                        "Daily consumption",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Dark rich color",
                        "Excellent taste",
                        "High nutritional content",
                        "Premium quality",
                    ],
                },
            ],
        },

        {
            id: 4,
            name: "MABROOM DATES",
            image: "/assets/img/Dates/Mabroom-Dates.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Retail packaging",
                        "Gift boxes",
                        "Healthy snacks",
                        "Hospitality industry",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Naturally sweet flavor",
                        "Firm texture",
                        "Premium appearance",
                        "Long shelf life",
                    ],
                },
            ],
        },

        {
            id: 5,
            name: "KIMIA DATES",
            image: "/assets/img/Dates/Kimia-Dates.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Desserts and sweets",
                        "Daily consumption",
                        "Food processing",
                        "Retail sales",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Soft texture",
                        "Rich taste",
                        "High nutritional value",
                        "Consumer favorite variety",
                    ],
                },
            ],
        },

        {
            id: 6,
            name: "DEGLET NOOR DATES",
            image: "/assets/img/Dates/Deglet-Noor-Dates.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Baking applications",
                        "Snack packs",
                        "Food processing",
                        "Retail packaging",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Semi-dry texture",
                        "Naturally sweet flavor",
                        "Good shelf life",
                        "Popular export variety",
                    ],
                },
            ],
        },

        {
            id: 7,
            name: "ZAHIDI DATES",
            image: "/assets/img/Dates/Zahidi-Dates.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Date processing industry",
                        "Healthy snacks",
                        "Date syrup production",
                        "Retail sales",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Golden color",
                        "Firm texture",
                        "Mild sweetness",
                        "Versatile applications",
                    ],
                },
            ],
        },

        {
            id: 8,
            name: "DATE PASTE",
            image: "/assets/img/Dates/Date-Paste.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery industry",
                        "Confectionery products",
                        "Energy bars",
                        "Food processing industries",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Natural sweetener",
                        "Easy processing",
                        "Rich flavor",
                        "Healthy sugar alternative",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Dates"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Dates Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality Dates products sourced from trusted
                        suppliers worldwide.
                    </p>

                    <div className="pp-grid">
                        {datesProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}